import { parseISO, format } from "date-fns";
import { es } from "date-fns/locale";

export function parseDateWithMonth(isoString) {
  const dateObj = parseISO(isoString);

  const localDate = format(dateObj, "MMMM d, yyyy", { locale: es }).replace(
    /^./,
    (c) => c.toUpperCase()
  );
  const localTime = format(dateObj, "h:mm a", { locale: es }).toLowerCase();

  return { date: localDate, time: localTime };
}

export function parseDate(isoString) {
  const dateObj = parseISO(isoString);

  const localDate = format(dateObj, "dd-MM-yyyy");
  const localTime = format(dateObj, "h:mm a").toLowerCase();

  return { date: localDate, time: localTime };
}

export const proveedorSteps = [
  { etapa: 1, description: "Envío de documentación" },
  { etapa: 2, description: "Validación de documentos" },
  { etapa: 3, description: "Validación de costos" },
  { etapa: 4, description: "Capacitación" },
  { etapa: 5, description: "Curso de Check y entrega de manuales" },
  { etapa: 6, description: "Contrato" },
  { etapa: 7, description: "Periodo de prueba" },
  { etapa: 8, description: "Subir documentación final" },
  { etapa: 9, description: "Entrega de chaleco y credencial física" },
];

export const projectSteps = [
  { etapa: 1, description: "Proyecto creado" },
  { etapa: 2, description: "Trabajo asignado" },
  { etapa: 3, description: "Instalador en camino" },
  { etapa: 4, description: "Instalador en sitio" },
  { etapa: 5, description: "Trabajo finalizado" },
  { etapa: 6, description: "Validación de trabajo" },
];
